// @flow

import Layout from '../model/entity/Layout';
import * as types from '../constants/ActionTypes';
import defaultInit2D from '../components/App/Viewer/renderer/Image2d/Image2d';
import { defaultInit3D } from '../components/App/Viewer/renderer/Image3d/Image3d';
import { to3DLibraryToolName } from '../components/App/Viewer/getVolumeManager';

const initialState: Layout = new Layout();

export default (layout: Layout = initialState, action: Object) => {
  switch (action.type) {
    case types.ADD_SELECTED_VIEW: {
      return {
        ...layout,
        ...layout.viewsGroup.splice(action.index, 0, action.index),
      };
    }

    case types.REMOVE_SELECTED_VIEW: {
      return {
        ...layout,
        ...layout.viewsGroup.splice(layout.viewsGroup.indexOf(action.index), 1),
      };
    }

    case types.SET_VIEWS_GROUP: {
      return {
        ...layout,
        viewsGroup: [...action.group],
      };
    }

    case types.SET_LAYOUT: {
      return {
        ...action.layout,
      };
    }

    case types.ADD_LAYOUT_ELEMENT: {
      return {
        ...layout,
        elements: [...layout.elements, action.element],
      };
    }

    case types.SET_LAYOUT_ELEMENT: {
      const newLayout = { ...layout };
      newLayout.elements[action.index] = action.element;
      return newLayout;
    }

    case types.UPDATE_LAYOUT_ELEMENT: {
      const newLayout = { ...layout };

      const selectedLayoutElement = layout.elements[action.viewIndex];
      const newLayoutElement = {...selectedLayoutElement, ...action.newProperties};

      newLayout.elements[action.viewIndex] = newLayoutElement;

      return newLayout;
    }

    case types.SET_LAYOUT_ELEMENT_CAMERA: {
      return {
        ...layout,
        elements: layout.elements.map((element, i) => {
          if (i !== action.index) return { ...element };
          return { ...element, initOptions: action.initOptions };
        }),
      };
    }

    case types.SET_LAYOUT_ELEMENTS: {
      return {
        ...layout,
        elements: action.elements,
      };
    }

    case types.SET_LAYOUT_GRID: {
      return {
        ...layout,
        columns: action.columns,
        rows: action.rows,
      };
    }

    case types.CHANGE_VIEW_SELECTED: {
      return {
        ...layout,
        selectedViewIndex: action.index,
      };
    }

    case types.SHOW_EXPLORER: {
      return {
        ...layout,
        showExplorer: action.show,
      };
    }

    case types.SHOW_HISTORY: {
      return {
        ...layout,
        showHistory: action.show,
      };
    }

    case types.SET_REF_LINES: {
      return {
        ...layout,
        isRefLines: !layout.isRefLines,
      };
    }

    case types.SET_SCROLL_TYPE: {
      return {
        ...layout,
        isContinuousScroll: !layout.isContinuousScroll,
      };
    }

    case types.SET_CURRENT_TOOL: {
      defaultInit2D.currentTool = action.currentTool;
      // defaultInit3D.currentTool = to3DLibraryToolName(action.currentTool);
      return {
        ...layout,
        currentTool: action.currentTool,
        showHistory: false,
      };
    }

    case types.RESET_LAYOUT_STATE: {
      return initialState;
    }

    case types.RESET_LAYOUT_ELEMENT_STATE: {
      const newLayout = { ...layout };
      const resetElement = { ...layout.elements[action.index], isPlayingCine: false, isSynchedFrames: false };
      newLayout.elements[action.index] = resetElement;
      return newLayout;
    }

    case types.SET_IS_3D_MODE_ENABLED: {
      return {
        ...layout,
        is3DModeEnabled: action.is3DModeEnabled,
      };
    }

    case types.SET_IS_MPR_MODE_ENABLED: {
      return {
        ...layout,
        isMPRModeEnabled: action.isMPRModeEnabled,
      };
    }

    default:
      return layout;
  }
};
